module.exports = kolibriCoreAppGlobal.coreVue.components.Navbar;